<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import RichTextEditor from '@/components/RichTextEditor.vue';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Layout, PageHeader, RichTextEditor },
	data() {
		return {
			title: 'Site Settings',
			userData: JSON.parse(localStorage.getItem('web_user')),
			alert_text: '',
			alert_active: false,
			assignmentsForm: null,
			locations: null,
		};
	},
	mounted() {
		this.getHomeAlertSettings();
		this.getLocationsWithUserTypes();
	},
	methods: {
		updateAssignmentSettings() {
			var token = localStorage.getItem('token');
			if (token) {
				var data = JSON.stringify({
					options: [
						{
							option_key: 'user_assignments',
							option_value: JSON.stringify(this.assignmentsForm),
							option_group: 'user_assignments',
						},
					],
				});

				var config = {
					method: 'put',
					url: 'user/options',
					headers: {
						Authorization: 'Bearer ' + token,
						'Content-Type': 'application/json',
					},
					data: data,
				};

				axios(config)
					.then((res) => {
						if (res.data.status == true) {
							Swal.fire({
								title: 'Success!',
								text: 'Settings Updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
						}
					});
			}
		},
		updateHomeAlertSettings() {
			var token = localStorage.getItem('token');
			if (token) {
				var data = JSON.stringify({
					options: [
						{
							option_key: 'homepage_alert',
							option_value: this.alert_text,
							option_group: 'homepage',
						},
						{
							option_key: 'homepage_alert_active',
							option_value: this.alert_active,
							option_group: 'homepage',
						},
					],
				});

				var config = {
					method: 'put',
					url: 'user/options',
					headers: {
						Authorization: 'Bearer ' + token,
						'Content-Type': 'application/json',
					},
					data: data,
				};

				axios(config)
					.then((res) => {
						if (res.data.status == true) {
							Swal.fire({
								title: 'Good job!',
								text: 'Alert Settings Updated successfully!',
								icon: 'success',
								width: 350,
								showConfirmButton: false,
								timer: 1500,
							});
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
						}
					});
			}
		},
		alertActiveToggle(e) {
			if (e.target.checked == true) {
				this.alert_active = true;
			}
		},
		getHomeAlertSettings() {
			axios.get('/user/options?option_group=homepage').then((res) => {
				this.alert_text = res.data.response[1].option_value;
				this.alert_active = res.data.response[0].option_value == 1 ? true : false;
			});
		},
		getAssignmentSettings() {
			axios
				.get('/user/options?option_key=user_assignments')
				.then((res) => {
					let { data : { response : { option_value : _SAVED_SETTINGS }}} = res;
					const SAVED_SETTINGS = JSON.parse(_SAVED_SETTINGS);
					if (SAVED_SETTINGS && Array.isArray(SAVED_SETTINGS) && SAVED_SETTINGS.length > 0) {
						let merged = [...SAVED_SETTINGS];
						const LOCATIONS = this.locations || [];
						// append locations that do not exists in the response array
						for (let i = 0; i < LOCATIONS.length; i++) {
							let found = false;
							for (let j = 0; j < SAVED_SETTINGS.length; j++) {
								const LOCATIONS_EXISTS = SAVED_SETTINGS[j].location_id == LOCATIONS[i].id;
								const TYPE_EXISTS = SAVED_SETTINGS[j].user_type_id == LOCATIONS[i].user_type_id;
								if (LOCATIONS_EXISTS && TYPE_EXISTS) {
									found = true;
									break;
								}
							}
							if (found == false) {
								merged.push({...LOCATIONS[i]});
							}
						}
						this.assignmentsForm = merged;
					}
				})
				.catch((err) => {
					if (err.response) {
						Swal.fire({
							title: 'Error!',
							text: err?.response?.data?.error?.message || "Something went wrong",
							icon: 'danger',
							width: 350,
							showConfirmButton: true,
						});
					}
				});
		},

		getLocationsWithUserTypes() {
			axios.get('/user/options/locations_user_types').then((res) => {
				this.locations = res.data.response;
				this.getAssignmentSettings();
			});
		},

		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			// if( user.middle_name.toLowerCase() != 'nmn' && user.middle_name && user.middle_name.length ){
			//     fullname += ' ' + user.middle_name;
			// }
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" />

		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<b-tabs justified content-class="p-3 text-muted">
							<!-- Alerts tab -->
							<b-tab active class="border-0">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-home"></i>
									</span>
									<span class="d-none d-sm-inline-block">General</span>
								</template>

								<form action="" @submit.prevent="updateHomeAlertSettings">
									<div class="row mt-5">
										<div class="col-12">
											<h5 class="card-title mb-3 font-size-18">Home Alert</h5>
										</div>

										<div class="col-6 mb-3">
											<div class="form-group mb-3">
												<label>Activate alert</label>
												<br />
												<input type="checkbox" name="is_alert_active" class="mb-3 pt-1" v-on:change="alertActiveToggle($event)" v-model="alert_active" />
												<span for="" class="mx-2">yes</span>
											</div>

											<div class="form-group">
												<label>Alert Text</label>
												<RichTextEditor cssClasses="form-control" v-model="alert_text" />
											</div>
										</div>

										<div class="col-6 mb-3"></div>

										<div class="col-12 mb-3">
											<b-button type="submit" class="float-end" variant="primary" title="Update User"> Update General Settings </b-button>
										</div>
									</div>
								</form>
							</b-tab>

							<b-tab class="border-0">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-home"></i>
									</span>
									<span class="d-none d-sm-inline-block">User Assignments</span>
								</template>

								<form action="" @submit.prevent="updateAssignmentSettings">
									<div class="row mt-5">
										<div class="col-12">
											<h5 class="card-title mb-3 font-size-18">User Assignments</h5>
										</div>

										<div class="col-12">
											<div class="table-responsive">
												<table class="table table-bordered table-hover table-striped align-middle mb-0">
													<thead class="table-light">
														<tr>
															<th scope="col">Location</th>
															<th scope="col">Type</th>
															<th scope="col">Volunteer</th>
															<th scope="col">Mentor</th>
														</tr>
													</thead>
													<tbody v-if="locations && locations.length && assignmentsForm && assignmentsForm.length">
														<tr v-for="(location, locationIndex) in locations" :key="locationIndex">
															<td>
																{{ location.location }}
																<input type="hidden" v-model="assignmentsForm[locationIndex].location_id" />
															</td>
															<td>
																{{ location.type }}
																<input type="hidden" v-model="assignmentsForm[locationIndex].user_type_id" />
															</td>
															<td>
																<b-form-select class="form-select w-75" v-model="assignmentsForm[locationIndex].volunteer_id">
																	<option v-for="user in location.users" :key="user.id" :value="user.id">{{ getFullName(user) }}</option>
																	<option slot="first" :value="0" selected disabled>-- Select --</option>
																</b-form-select>
															</td>
															<td>
																<b-form-select class="form-select w-75" v-model="assignmentsForm[locationIndex].mentor_id">
																	<option v-for="user in location.users" :key="user.id" :value="user.id">{{ getFullName(user) }}</option>
																	<option slot="first" :value="0" selected disabled>-- Select --</option>
																</b-form-select>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

										<div class="col-12 my-4">
											<b-button type="submit" class="float-end" variant="primary" title="Update Settings"> Update </b-button>
										</div>
									</div>
								</form>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<style scoped>
#mntc_thankyou_page_content p {
	font-size: 16px !important;
	text-align: center;
}

#mntc_thankyou_page_content h4 {
	color: #495057;
	font-size: 24px;
	text-align: center;
}
</style>
